<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
            title="Contractors"
            icon="fas fa-list"
            buttonLabel="CREATE NEW COMPANY"
            buttonIcon="fas fa-plus"
            (buttonClick)="createNewCompany()"
          >
        </card-section-header>
          <!-- Filters -->
          <div class="row">
            <div class="col-md-12">
              <div class="filter-flex-row">
                <div>
                  <label>Company Name:</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChangedCompany($event)"></text-filter-box>
                </div>
                <div *ngIf="isFilterLoading" class="small-spinner">
                  <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <a style="float: right;" [routerLink]="['/', routeRole, 'contractor-site-owner-links']">Go to Site Owner Links</a>
            </div>
          </div>
          <br>
          <!-- Table -->
          <div class="row">
            <div class="col-md-12">
              <p-table
                [value]="contractors"
                [autoLayout]="true"
                selectionMode="single"
                (onRowSelect)="onRowSelect($event)"
                (onSort)="customSort($event)"
                [sortField]="defaultSortField"
                [lazy]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Id</th>
                    <th [pSortableColumn]="'name'">Company Name
                      <p-sortIcon [field]="'name'"></p-sortIcon>
                    </th>
                    <th>Manager</th>
                    <th>Information</th>
                    <th [pSortableColumn]="'oem'">OEM
                      <p-sortIcon [field]="'oem'"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-company>
                  <tr [pSelectableRow]="company">
                    <td>{{ company.id }}</td>
                    <td>{{ company.name }}</td>
                    <td>{{ company.manager ? company.manager : 'N/A' }}</td>
                    <td>{{ company.additionalInfo }}</td>
                    <td class="table-cell-centered">
                      <span *ngIf="company.oem"><i class="fas fa-check-circle success"></i></span>
                      <span *ngIf="!company.oem"><i class="fas fa-times-circle danger"></i></span>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="3">No contractors found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Create Contractor" [(visible)]="createCompanyModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="createCompanyForm" (ngSubmit)="onCreateCompanyFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Additional Information</label>
          <input type="text" class="form-control" formControlName="additionalInfo" placeholder="" />
        </div>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="createCompanyModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onCreateCompanyFormSubmit()" [disabled]="!createCompanyForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>
